import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'antd';

const columns = [
	{
		title: 'BLOOD TYPE',
		dataIndex: 'blood_type_name',
		width: 100,
		fixed: 'left',
	},
	{
		title: 'BAG ID',
		dataIndex: 'blood_bag_id',
		width: 100,
	},
	{
		title: 'STORAGE',
		dataIndex: 'storage_name',
		width: 100,
	},
	{
		title: 'EXTRACTED DATE',
		dataIndex: 'date_extracted',
		width: 100,
	},
	{
		title: 'EXPRIRATION DATE',
		dataIndex: 'expiration_date',
		width: 100,
	},
	{
		title: 'STATUS',
		dataIndex: 'status_name',
		width: 100,
		fixed: 'right',
	},
];

class ProductListTable extends React.Component {
	BloodProductDetails = record => {
		const { onSubmit, loading } = this.props;
		onSubmit(record);
	};

	render() {
		const { Data, loading } = this.props;

		return (
			<Table
				loading={loading}
				columns={columns}
				dataSource={Data}
				onRow={record => ({
					onDoubleClick: () => {
						this.BloodProductDetails(record);
					},
				})}
				scroll={{ x: 1500 }}
			/>
		);
	}
}

ProductListTable.propTypes = {
	Data: PropTypes.array,
};

export default ProductListTable;
